import EventEmitter from 'eventemitter3'

export const pubsub = new EventEmitter()